import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams, SortDirection } from '@ag-grid-community/core';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { AgExpandAllRows } from '@shared/utils';

export interface AgExpandHeaderParams extends IHeaderParams {
  sortChanged$?: Subject<null>;
}

@Component({
  imports: [IconComponent, TooltipDirective],
  styles: [
    `
      :host {
        @apply flex h-full w-full items-center justify-center;
      }
    `,
  ],
  template: `
    <aux-icon
      name="ChevronsDown"
      [auxTooltip]="'Expand All Rows'"
      (click)="toggleRowExpand(true)"
      class="cursor-pointer"
    />

    <aux-icon
      name="ChevronsUp"
      class="ml-[5px] cursor-pointer"
      [auxTooltip]="'Collapse All Rows'"
      (click)="toggleRowExpand(false)"
    />

    <div class="flex items-center" (click)="toggleSort()">
      <div
        class="ml-[10px] text-base text-aux-black"
        [innerHTML]="params.template || params.displayName"
      ></div>

      @if (params.enableSorting) {
        <span class="ag-sort-indicator-container">
          @if (currentSort === 'asc') {
            <span class="ag-sort-indicator-icon ag-sort-ascending-icon" aria-hidden="true">
              <span class="ag-icon ag-icon-asc" role="presentation"></span>
            </span>
          }
          @if (currentSort === 'desc') {
            <span class="ag-sort-indicator-icon ag-sort-descending-icon" aria-hidden="true">
              <span class="ag-icon ag-icon-desc" role="presentation"></span>
            </span>
          }
        </span>
      }
    </div>
  `,
})
export class AgExpandHeaderComponent implements IHeaderAngularComp {
  private readonly destroyRef = inject(DestroyRef);

  currentSort: SortDirection = null;
  params!: AgExpandHeaderParams;
  visible = true;

  agInit(params: AgExpandHeaderParams): void {
    this.params = params;
    this.currentSort = params.column.getSort() || null;

    if (params.sortChanged$) {
      params.sortChanged$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.currentSort = params.column.getSort() || null;
      });
    }
  }

  refresh(): boolean {
    return false;
  }

  toggleRowExpand(expanded: boolean) {
    AgExpandAllRows({ expanded, gridApi: this.params.api });
  }

  toggleSort() {
    if (!this.params.enableSorting) {
      return;
    }

    this.currentSort = this.currentSort === 'asc' ? 'desc' : 'asc';
    this.params.setSort(this.currentSort);
  }
}
